import {InputValidator} from "../InputValidationHandler";
import FormValidations from "../FormValidations";

export class DefaultEmailValidator implements InputValidator {
    private readonly isEmailMandatory: boolean;

    constructor(isEmailMandatory: boolean = true) {
        this.isEmailMandatory = isEmailMandatory;
    }

    isValid(element: HTMLInputElement) {
        if (this.isEmailMandatory) {
            return FormValidations.emailIsValid(element.value);
        }
        return FormValidations.checkOptionalInput(element.value, FormValidations.emailIsValid);
    }
}